import { render, staticRenderFns } from "./SmallBlogItem.vue?vue&type=template&id=946c0a42&scoped=true"
import script from "./SmallBlogItem.vue?vue&type=script&lang=js"
export * from "./SmallBlogItem.vue?vue&type=script&lang=js"
import style0 from "./SmallBlogItem.vue?vue&type=style&index=0&id=946c0a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946c0a42",
  null
  
)

export default component.exports